import { RequestCreditLimitIncreaseCTA } from "./ctas";
export var RequestCreditLimitIncreaseIA = function RequestCreditLimitIncreaseIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return REQUEST_CREDIT_LIMIT_INCREASE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [SUBMIT_REQUEST_USING_BUTTON(strictLocalize), PLEASE_NOTE(strictLocalize), TIMELINE(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(_context) {
        return RequestCreditLimitIncreaseCTA(strictLocalize).label;
      },
      linkBuilder: function linkBuilder(_context) {
        var _RequestCreditLimitIn, _RequestCreditLimitIn2;
        return (_RequestCreditLimitIn = (_RequestCreditLimitIn2 = RequestCreditLimitIncreaseCTA(strictLocalize)).getLink) === null || _RequestCreditLimitIn === void 0 ? void 0 : _RequestCreditLimitIn.call(_RequestCreditLimitIn2);
      }
    }
  };
};
var REQUEST_CREDIT_LIMIT_INCREASE = function REQUEST_CREDIT_LIMIT_INCREASE(strictLocalize) {
  return strictLocalize({
    id: "ugdDrA",
    defaultMessage: "Request credit limit increase"
  });
};
var SUBMIT_REQUEST_USING_BUTTON = function SUBMIT_REQUEST_USING_BUTTON(strictLocalize) {
  return strictLocalize({
    id: "LkoWL2",
    defaultMessage: "If you would like to apply to increase your limit, please click on the button below to submit a request."
  });
};
var PLEASE_NOTE = function PLEASE_NOTE(strictLocalize) {
  return strictLocalize({
    id: "lRQgRb",
    defaultMessage: "Please note, if you've applied for an increase within the last 3 months, your account may not have this button and instead require manual review from our payments team."
  });
};
var TIMELINE = function TIMELINE(strictLocalize) {
  return strictLocalize({
    id: "Jl6C3w",
    defaultMessage: "We will review your application and you will typically hear back from us in 3-7 business days."
  });
};